import React from 'react'
import { Button, Tooltip } from '@mui/material';
import { ContentCopyIcon } from '../shared/icons';
import theme from '../app/app-theme';

interface CopyToClipboardProps {
    value: string;
    tooltip: string;
}

const CopyToClipboard: React.FC<CopyToClipboardProps> = ({value, tooltip}) => {
    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(value);
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    };

    return (
            <Tooltip title={tooltip}>
                <Button onClick={handleCopy} sx={{minWidth: '30px'}}>
                    <ContentCopyIcon sx={{height: '20px', color: `${theme.palette.success.main}`}}/>
                </Button>
            </Tooltip>
    );
}

export default CopyToClipboard;